<template>
    <div class="container">
        <div class="box">
            <div class="text_download"></div>
            <div class="logo_img_div">
                <img class="logo_img" src="@/assets/logo.png"/>
            </div>
            <div class="text_tip">职能达</div>
            <div class="text_tip">随时随地，想学就学。</div>
        </div>
        <div class="btn_group">
          <div class="btn_div">
              <div class="android_btn_css" @click="redirect(1)">
                  <div class="btn_box">
                    <img style="width:20px;height:20px;" src="@/assets/icon_android.png" />
                    <div>安卓版下载</div>
                  </div>
              </div>
              <div class="ios_btn_css" @click="redirect(2)">
                  <div class="btn_box">
                    <img style="width:20px;height:20px;" src="@/assets/icon_ios.png" />
                    <div>苹果版下载</div>
                  </div>
              </div>
          </div>
        </div>
        <div id="showad" v-show="showDark">
            <!-- <img @click="img_click()" class="close_img" src="@/assets/icon_del_img.png"/> -->
            <div class="pop">
                <img class="right_img" src="@/assets/img_lead.png"/>
            </div>
            <div class="text">
                <!-- <div class="inline">
                    <div class="num">
                        <div>1</div>
                    </div>
                    <div>点击右上角的 </div>
                    <img style="width:30px;height:30px;" src="@/assets/btn_right.png"/>
                    <div> 按钮</div>
                </div>
                <div class="inline">
                    <div class="num">
                        <div>2</div>
                    </div>
                    <div>选择 </div>
                    <img style="width:120px;height:30px;" src="@/assets/btn_browser.png"/>
                </div> -->
                <img style="width:260px;height:90px;" src="@/assets/btn_browser.png" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: 'tip',
    data: () => ({
        showDark: false,
        androidDownloadUrl: '',
        iosDownloadUrl: '',
    }),
    created () {
        this.init()
        if (this.isWeixin()) {
            this.showDark = true
        }
    },
    methods: {
        async init () {
            var baseUrl = process.env.VUE_APP_BASE_API
            var that = this
            axios.get(baseUrl + "/outside/download").then(function(res){
               that.androidDownloadUrl = res.data.data.apkUrl
               that.iosDownloadUrl = res.data.data.ioslink
            })
        },
        redirect (flag) {
            if (this.isWeixin()) {
                this.showDark = true
            } else {
                if (flag == 1) {
                    window.location = this.androidDownloadUrl
                } else {
                    window.location = this.iosDownloadUrl
                }
            }
            
        },
        isWeixin () {
            var ua = window.navigator.userAgent.toLowerCase();
            return (ua.match(/Micromessenger/i)=='micromessenger' ? true : false)
        },
    }
    
}
</script>

<style scoped>
.inline {
    display: flex;
}
.num {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    background: #F05F27;
    border-radius: 50%;
}
.container {
    position: relative;
    width: 100vw;
    height: 100vh;
}
.box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-bottom: 30px ;
}
.text_download {
    font-size: 35px;
    font-weight: 700;
    margin-bottom: 70px ;
}
.btn_group {
    display: flex;
    justify-content: center;
    width: 100%;
}
.btn_div {
    width: 80%;
    display: flex;
    justify-content: space-around;
}
.android_btn_css {
    display: flex;
    justify-content: center;
    width: 130px;
    height: 40px;
    color: white;
    background-color: #4ec36c;
    border-radius: 10px;
}
.ios_btn_css {
    display: flex;
    justify-content: center;
    width: 130px;
    height: 40px;
    color: white;
    background: #268AF4;
    border-radius: 10px;
}
.logo_img_div {
    width: 100%;
    height: 80px;
}
.logo_img {
    width: 70px;
    border-radius: 50%;
}
#showad {
    position: relative;
    height: 100%;
    width: 100%;
    background: rgba(51, 50, 50, 0.7);
    background-size: 100% 100%;
    z-index: 111;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    opacity: 0.9;
}
#showad .pop {
    position: absolute;
    top: 0;
    right: 2em;
    margin: 0 auto;
    font-size: 1rem;
    color: azure;
}

#showad .text {
    position: absolute;
    top: 9em;
    left: 3em;
    margin: 0 auto;
    font-size: 20px;
    color: azure;
}

.close_img {
    position: absolute;
    top: 0;
    right: 0.2em;
    width: 25px;
    height: 25px;
}
.btn_box {
    display: flex;
    align-items: center;
}

.right_img {
    position: absolute;
    right: 0;
}

</style>